require('./bootstrap');

import Vue from 'vue';
//Rutas del website
import Router from './router.js';

//Librerias globales
import Library from './libs.js';
Vue.use(Library);

//Componentes del website
import components from './components/components.js';
Vue.use(components);

import cart, { cartBus } from './cart';
Vue.prototype.$cart = cart;
Vue.prototype.$cartBus = cartBus;

const csrf = document.head.querySelector('meta[name="csrf-token"]');
if (csrf) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf.content;
}

window.Vue=Vue;

//Instancia principal
const app = new Vue({
    el: '#app',
    router:Router
});
